import React from 'react';
import { Button } from 'semantic-ui-react';
import Big from 'bignumber.js';
import { columns } from 'erisxkit/client';
import { formatTimeLocal, formatDateLocal } from '../utils/time';

const cols = (
  showReversalModal,
  balancesView,
  futures = false,
  isReadOnlyRole,
) => [
  {
    Header: 'Trade Date',
    id: 'date',
    filterable: false,
    headerClassName: 'pull-left',
    accessor: ({ date, reportDate }) =>
      reportDate ? formatDateLocal(reportDate) : formatDateLocal(date),
    width: 100,
  },
  {
    Header: 'Exchange',
    accessor: 'exchangeMicCode',
    id: 'exchangeMicCode',
    sortable: false,
  },
  {
    Header: 'Product',
    id: 'productSymbol',
    accessor: 'productSymbol',
  },
  {
    Header: 'Contract',
    id: 'clearingSymbol',
    accessor: 'clearingSymbol',
    sortable: false,
  },
  {
    Header: 'Member Name',
    id: 'memberName',
    accessor: 'memberName',
    sortable: false,
  },
  {
    Header: 'Account',
    id: 'accountLabel',
    accessor: 'accountLabel',
    width: columns.ACCOUNT_NAME,
    sortable: false,
  },
  {
    Header: 'Trade Type',
    accessor: (row) => row.tradeType || row.trdType,
    id: 'tradeType',
    show: futures,
    sortable: false,
  },
  {
    Header: 'Quantity',
    accessor: 'qty',
    className: 'mono',
    id: 'qty',
    sortable: false,
  },
  {
    Header: 'Price',
    accessor: 'px',
    className: 'mono',
    id: 'px',
  },
  {
    Header: 'Trade Type',
    accessor: (row) => row.tradeType || row.trdType,
    id: 'tradeType',
    show: !futures,
    sortable: false,
  },
  {
    Header: 'Reserved Margin',
    accessor: (row) => row.initialMargin,
    className: 'mono',
    id: 'initialMargin',
    show: futures,
    sortable: false,
  },
  {
    Header: 'Execution Time',
    id: 'execTime',
    width: 205,
    headerClassName: 'pull-left',
    accessor: (row) => formatTimeLocal(row.time),
    sortable: false,
  },
  {
    Header: 'Report Time',
    id: 'reportTime',
    width: 205,
    headerClassName: 'pull-left',
    accessor: (row) => formatTimeLocal(row.reportTime),
    sortable: false,
  },
  {
    Header: 'Aggressor',
    accessor: 'aggressor',
    id: 'aggressor',
  },
  {
    Header: 'Exchange Fee',
    id: 'exchange',
    className: 'mono',
    accessor: (row) =>
      `${row.exchangeFee || row.exchangeFees || ''} ${row.feeType || ''}`,
    sortable: false,
  },
  {
    Header: 'Clearing Fee',
    id: 'clearingFee',
    className: 'mono',
    accessor: ({
      clearingFee = 0,
      clearingFees = 0,
      feeType,
      deliveryFee = 0,
    }) => {
      // need this because 'trades' and 'trade_journals' endpoints have
      // different names for the same attr, can be removed once we deprecate one of the endpoints
      const feeClearing = clearingFee || clearingFees || 0;
      const feeClearingTotal = Big(feeClearing).plus(deliveryFee).toFixed();
      return `${feeClearingTotal} ${feeType || ''}`;
    },
    sortable: false,
  },
  {
    Header: 'Spread ID',
    id: 'secondaryExecId',
    accessor: 'secondaryExecId',
    sortable: false,
  },
  {
    Header: 'Submitter',
    id: 'submitter',
    accessor: 'submitter',
    sortable: false,
  },
  {
    Header: 'Trade Id',
    accessor: 'tradeId',
    id: 'tradeId',
    sortable: false,
  },
  {
    Header: 'CAR',
    accessor: 'customerAccountRef',
    id: 'customerAccountRef',
    sortable: false,
  },
  {
    Header: 'CTI',
    id: 'cti',
    accessor: 'cti',
    sortable: false,
  },
  {
    Header: 'Origin',
    id: 'origin',
    accessor: 'origin',
    sortable: false,
  },
  {
    id: 'reversal',
    accessor: (row) => (
      <Button
        disabled={!!row.reversalUuid || isReadOnlyRole}
        circular
        className="reversalButton"
        size="mini"
        onClick={() => showReversalModal(row)}
        icon="undo"
        color="red"
        content={`Reverse${row.reversalUuid ? 'd' : ''}`}
      />
    ),
    width: 95,
    show: !balancesView,
    sortable: false,
  },
];

export default cols;
